import styled from "styled-components";
import { colors } from "utils";

// The in-page tab strip the report frames share (Student Reports, Class
// Reports): a hairline under the row, the active tab underlined in OKO blue.
export const TabList = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 0 24px;
  border-bottom: 1px solid #acafad;
`;

// Bold in BOTH states, and the weight never changes on select: the frame draws
// every tab at Inter Bold, and swapping 400 for 700 on the active one reflows
// its neighbours by a pixel or two every time a teacher switches tabs.
export const Tab = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  border: none;
  background: none;
  cursor: pointer;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.25px;
  white-space: nowrap;
  color: ${(props) => (props.$active ? "#524fc9" : colors.nightlyWoods500)};
  box-shadow: ${(props) => (props.$active ? "inset 0 -3px 0 #605dec" : "none")};
`;
